import styled from 'styled-components'

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 8px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ErrorSection = styled.div<{ $bottomSheetMode?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 8px;

  ${({ $bottomSheetMode }) => ($bottomSheetMode ? `margin-bottom: 50px;` : `margin: 50% 0px;`)}
  text-align: center;

  svg {
    margin-bottom: 20px;
  }
`
export const FooterErrorSection = styled.div`
  position: fixed;
  bottom: 24px;
  width: calc(100% - 48px);
`

export const Wrapper = styled.div``

export const Divider = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  margin: 24px 0;
  border: 1px dashed var(--gray200);
  border-style: dashed none none none;
`
